import { createModel } from "nyax";
import { Knowledge, KnowledgeQuery } from "src/models/knowledge";
import { KnowledgeEntityModel } from "src/store/models/entity/knowledge/entity";
import { createUISideListWithPermissionModel } from "src/store/models/ui/_shared";

export const KnowledgeSideUIModel = createModel(
  class extends createUISideListWithPermissionModel<Knowledge, KnowledgeQuery>({
    setItems: (getContainer, items) =>
      getContainer(KnowledgeEntityModel).actions.setItems.dispatch(items),
    getItems: (getContainer) =>
      getContainer(KnowledgeEntityModel).getters.items,
    getItem: (getContainer, id) =>
      getContainer(KnowledgeEntityModel).state.byId[id],
    getItemId: (item) => item.id,
  }) {
    public effects() {
      return {
        ...super.effects(),
        initial: async () => {
          this._initial({
            initialAction: (
              pageIndex: number,
              pageSize: number,
              query: KnowledgeQuery
            ) =>
              this.dependencies.serviceClient.knowledge.list(
                pageIndex,
                pageSize,
                query
              ),
          });
        },
      };
    }
  }
);
